module.exports = __webpack_public_path__ + "media/images/flags/ma-d3406e7580cbe7f678a9a202a4644a42.svg";